module.exports = __webpack_public_path__ + "img/40_38_048_410.32c3bb4f.jpg";